<template>
  <v-container class="white" grid-list-xl fluid ma-0 pa-0>
    <div class="text-center">
      <v-btn class="ma-2" color="success" outlined><v-icon left>mdi-cloud</v-icon>
        Photos and Video's
      </v-btn>
    </div>

    <v-layout justify-center wrap >  
      <v-flex xs12 sm6 md3 v-for="item in clttsGallery" :key="item.order">
        <v-responsive>
          <v-card>
            <v-sheet
            class="d-flex"
            color="grey lighten-3"
          >
          <v-img v-if="item.type ==='Photo'" class="white--text pa-0" height="280" :src=item.photo @click.stop="navigateTo(item.url)"></v-img>
          </v-sheet>
         </v-card>
        </v-responsive>
        <v-spacer/>
        <iframe v-if="item.type==='Video'" class="mx-1"  width="450" height="300" :src=item.url frameborder="0" allow="accelerometer; controls; encrypted-media; gyroscope;" allowfullscreen></iframe>
        <div class="heading center">{{item.name}}</div>
      </v-flex>
      <v-flex xs12 md12>
      </v-flex>
    </v-layout><br><br>

  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'

export default {
  data : () => ({
    clttsGallery: []
  }),
  methods: {
    navigateTo (item) {
      window.open(item, '_blank')
    }
  },
  async mounted () {
    this.clttsGallery = (await ReportServices.getAllGalleryInfo()).data
    this.clttsGallery.sort()
  }
}
</script>
